import { Point, DatasourceId, OpenSiteId } from '../types';

export enum ActiveLocationType {
  MyLocation = 'MyLocation',
  Datasource = 'Datasource',
  OpenSite = 'OpenSite',
  ReverseGeocodedLocation = 'ReverseGeocodedLocation',
}

// A mutually-exclusive description of what the map is currently focused on.
export type ActiveLocation =
  | { type: ActiveLocationType.MyLocation; point: Point }
  | { type: ActiveLocationType.Datasource; point: Point; datasourceId: DatasourceId }
  | { type: ActiveLocationType.OpenSite; point: Point; openSiteId: OpenSiteId }
  | { type: ActiveLocationType.ReverseGeocodedLocation; point: Point };
